module.exports = __webpack_public_path__ + "img/paper-clip.176886e9.png";